/**
 * Manual Room Host Tool
 *
 * Standalone host that draws rooms the "old way" — click-to-place points via
 * the `MeasureSubTool` (MeasureEngine) — paired with a `RoomKindAdapter` so the
 * drawn polygon commits through the same `create_room` path. Restores the
 * former `ManualRoomDrawTool` as a flat sibling toolbar entry on the
 * host/subtool plumbing.
 */

import { FloorplanToolBase } from './FloorplanToolBase';
import { Viewer } from '../../../viewer/viewer';
import { IPersona } from '../../types';
import { SubToolHosting } from '../../SubToolHosting';
import { MeasureSubTool } from './MeasureSubTool';
import { RoomKindAdapter } from './line-tool/RoomKindAdapter';
import { setRoomSphereScale } from './RoomHostTool';

export class ManualRoomHostTool extends SubToolHosting(FloorplanToolBase) {
  readonly name = 'manual_room_draw';

  constructor(viewer: Viewer, persona: IPersona) {
    super(viewer, persona);
    const adapter = new RoomKindAdapter();
    const subtool = new MeasureSubTool(viewer, persona, adapter);
    const ctx = adapter.createSelectionContext(viewer, persona);
    this.initSubToolHosting(subtool, adapter, ctx);
  }

  // Lifecycle is otherwise owned by SubToolHosting; these overrides only add
  // the vertex-sphere sizing (full size in the tool, half size outside).

  protected onEnable(): void {
    super.onEnable();
    setRoomSphereScale(this.viewer, 1);
  }

  protected onDisable(): void {
    setRoomSphereScale(this.viewer, 0.5);
    super.onDisable();
  }

  protected onFloorChanged(): void {
    this.pushBasePlane();
  }
}
